export default [{
	"sort": 1,
	"icon": "",
	"id": 6905,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 65825,
		"is_sell": true,
		"pack_cost": "0.00",
		"sales": 487,
		"goods_type": 1,
		"cover_img": "",
		"property": [],
		"goods_meals_info": [],
		"is_add": 1,
		"use_spec": false,
		"entity": [{
			"spec_id": "",
			"trade_mark": "11110090",
			"id": "9ad36aa96636c246",
			"stock": "9999956.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/19/fda6dd99c83af02353.jpg",
			"num": 1,
			"price": 18.5,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 18.5,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/19/fda6dd99c83af02353.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "购买三明治,享早餐指定饮品半价",
		"is_follow_suit": 1,
		"stock": "9999956.00",
		"type": 2,
		"is_label": 0,
		"name": "奈雪早餐",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/19/fda6dd99c83af02353.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "奈雪早餐",
	"is_show_backstage": 0
}, {
	"sort": 2,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/30/458c5a14fb2f190f96.png?imageView2/0/w/200/h/200",
	"id": 6208,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 24516,
		"pack_cost": "0.00",
		"sales": 1278,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000070",
			"id": "5d79de67251ea00e",
			"stock": "10485.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/29/4a62ee45dd527609ed.jpg",
			"num": 1,
			"price": 18,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 18,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/29/4a62ee45dd527609ed.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "酥软口感,进口奶油搭配特制巧克力内馅",
		"use_spec": false,
		"stock": "10485.00",
		"type": 1,
		"is_label": 0,
		"name": "脏脏王",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/29/4a62ee45dd527609ed.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 24517,
		"pack_cost": "0.00",
		"sales": 1228,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000071",
			"id": "2b3f1ea3ecabd22e",
			"stock": "10308.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/29/99daa7b20061efab10.jpg",
			"num": 1,
			"price": 18,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 4,
		"price": 18,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/29/99daa7b20061efab10.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "精选北川半兵卫抹茶粉和秘制红豆泥",
		"use_spec": false,
		"stock": "10308.00",
		"type": 1,
		"is_label": 0,
		"name": "抹茶王",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/29/99daa7b20061efab10.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 68339,
		"pack_cost": "0.00",
		"sales": 44429,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5EA54C3D0E4279185",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5EA54C3D0E9682750",
				"value": "去冰"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5EA54C3D0F2A37322",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5EA54C3D0F70A1000",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5EA54C3D0FAFE7320",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010025",
			"id": "72cf1279c0a422ce",
			"stock": "9999817.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/26/559a075d81060b23c7.jpg",
			"num": 1,
			"price": 30,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 0,
		"price": 30,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/26/559a075d81060b23c7.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "饱满大颗的新鲜杨梅,满杯手工去核,搭配茉莉初雪茶底,清爽多汁",
		"use_spec": false,
		"stock": "9999817.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气杨梅",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/26/559a075d81060b23c7.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 68345,
		"pack_cost": "0.00",
		"sales": 16322,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5EA55088766CC7824",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5EA5508876F271659",
				"value": "去冰"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5EA55088776843559",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5EA5508877A528469",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5EA5508877E5A6908",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010043",
			"id": "c7c6f8fd34040338",
			"stock": "999950.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/26/ea8fc439fddf2f62e3.jpg",
			"num": 1,
			"price": 32,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 32,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/26/ea8fc439fddf2f62e3.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "霸气杨梅和酸奶的首次搭配,甘甜可口",
		"use_spec": false,
		"stock": "999950.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气酸奶杨梅",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/26/ea8fc439fddf2f62e3.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "新品推荐",
	"is_show_backstage": 0
}, {
	"sort": 3,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/30/458c5a14fb2f190f96.png?imageView2/0/w/200/h/200",
	"id": 6387,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 31826,
		"pack_cost": "0.00",
		"sales": 70462,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000017",
			"id": "2e3f40b8f6decb2a",
			"stock": "1000498.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/28/be484557ff7cfa4dba.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/28/be484557ff7cfa4dba.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "马来西亚D24榴莲王果肉+芒果干，爆浆的榴莲馅，这款是榴莲控的最爱。",
		"use_spec": false,
		"stock": "1000498.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气榴莲王",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/28/be484557ff7cfa4dba.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31507,
		"pack_cost": "0.00",
		"sales": 199583,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2B483FA903805",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2B484016A8529",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2B48405642832",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2B48409616050",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD789B45391F4495",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD789B453D023182",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD789B4540531795",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010000",
			"id": "097aad038aeeb0ea",
			"stock": "998101.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/2a4b2697bec6f7e502.jpg",
			"num": 1,
			"price": 25,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 25,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/2a4b2697bec6f7e502.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪明星产品。优选进口新奇士橙，搭配严选茉莉毛尖茶底，橙意满满。",
		"use_spec": false,
		"stock": "998101.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气橙子",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/2a4b2697bec6f7e502.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31532,
		"pack_cost": "0.00",
		"sales": 5104,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1218,
				"code": "Z5D612C34C8EF06658",
				"value": "标准(芝士)"
			}, {
				"is_default": 0,
				"id": 1166,
				"code": "Z5D612C34C93705460",
				"value": "芝士换酸奶"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5EA8DBDA4371C5994",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 1164,
				"code": "Z5EA8DBDA43C415239",
				"value": "冰沙"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5EA8DBDA4404E3515",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78286916115856",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD78286919682277",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD7828691CB89112",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010050008",
			"id": "f8114313a48c5c4a",
			"stock": "1000314.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/19/a3ee1fa72435259a73.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 4,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/19/a3ee1fa72435259a73.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "精选优质巨峰葡萄、手工去皮去籽、加入带兰桂花香，经中度焙火的金观音茶中，搭配轻盈香甜芝士奶盖",
		"use_spec": false,
		"stock": "1000314.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气芝士葡萄",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/19/a3ee1fa72435259a73.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 16808,
		"pack_cost": "0.00",
		"sales": 115495,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000024",
			"id": "2e89b669b329c292",
			"stock": "10704.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/28/94d8440ab7b4fed802.jpg",
			"num": 1,
			"price": 20,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 5,
		"price": 20,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/28/94d8440ab7b4fed802.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "大大的一根魔法棒，加入淡奶油和进口酵母，配上经典的草莓鲜果。好看的外表和经典的口味造就的一款奈雪明星产品。",
		"use_spec": false,
		"stock": "10704.00",
		"type": 1,
		"is_label": 0,
		"name": "草莓魔法棒",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/28/94d8440ab7b4fed802.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31424,
		"pack_cost": "0.00",
		"sales": 125010,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1218,
				"code": "Z5D5BA2BB31A145049",
				"value": "标准(芝士)"
			}, {
				"is_default": 0,
				"id": 1166,
				"code": "Z5D5BA2BB320FA8410",
				"value": "芝士换酸奶"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 0,
				"id": 582,
				"code": "Z5E5E2BC316DD78061",
				"value": "标准冰"
			}, {
				"is_default": 1,
				"id": 1164,
				"code": "Z5E5E2BC316A215600",
				"value": "冰沙"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2BC3171CA8287",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2BC317A175989",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2BC317F896724",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD785286B9689681",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD785286BCF74540",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD785286C0687027",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010050003",
			"id": "ee375ed5ae7f77eb",
			"stock": "1002053.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/1cb88e6cd2fbcefb2a.jpg",
			"num": 1,
			"price": 29,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 29,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/1cb88e6cd2fbcefb2a.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪明星产品。选用奈雪自有草莓园新鲜草莓，搭配严选茉莉毛尖茶底，淋上轻盈香滑的芝士奶盖。",
		"use_spec": false,
		"stock": "1002053.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气芝士草莓",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/1cb88e6cd2fbcefb2a.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "招牌热卖",
	"is_show_backstage": 0
}, {
	"sort": 8,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/28/bfeae4de9de15a0f88.png?imageView2/0/w/200/h/200",
	"id": 2522,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 31826,
		"pack_cost": "0.00",
		"sales": 70462,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000017",
			"id": "2e3f40b8f6decb2a",
			"stock": "1000498.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/28/be484557ff7cfa4dba.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/28/be484557ff7cfa4dba.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "马来西亚D24榴莲王果肉+芒果干，爆浆的榴莲馅，这款是榴莲控的最爱。",
		"use_spec": false,
		"stock": "1000498.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气榴莲王",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/28/be484557ff7cfa4dba.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31544,
		"pack_cost": "0.00",
		"sales": 46215,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000018",
			"id": "08a87a5ad6fa8648",
			"stock": "100413.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/28/6e4829e475329d4836.jpg",
			"num": 1,
			"price": 20,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 20,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/28/6e4829e475329d4836.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "粉嫩的面包体加入了火龙果果泥，颜值和健康的共存，满满的香浓芝士内陷搭配柔软有嚼劲的软欧包，葡萄干的加缀增添丰富有层次的口感，让你一试喜欢。",
		"use_spec": false,
		"stock": "100413.00",
		"type": 1,
		"is_label": 0,
		"name": "蜜蜜芝士火龙果",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/28/6e4829e475329d4836.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 27016,
		"pack_cost": "0.00",
		"sales": 169990,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000093",
			"id": "85ab649f81d89e90",
			"stock": "1000106.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/10/11/e2035bc2f7003ad0e9.jpg",
			"num": 1,
			"price": 16,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 16,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/10/11/e2035bc2f7003ad0e9.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "紫薯醇香包裹蜜润红豆，麻薯带来超长拉丝惊喜",
		"use_spec": false,
		"stock": "1000106.00",
		"type": 1,
		"is_label": 0,
		"name": "紫薯嘟嘟",
		"images": "https://img-shop.qmimg.cn/s23107/2019/10/11/e2035bc2f7003ad0e9.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 27014,
		"pack_cost": "0.00",
		"sales": 255254,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000090",
			"id": "7220777710a535e7",
			"stock": "1000217.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/10/11/3cf65a33efba914504.jpg",
			"num": 1,
			"price": 16,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 16,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/10/11/3cf65a33efba914504.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "咸香蛋黄浓郁细腻注入经典芋泥甜咸风味正适宜",
		"use_spec": false,
		"stock": "1000217.00",
		"type": 1,
		"is_label": 0,
		"name": "咸蛋黄嘟嘟",
		"images": "https://img-shop.qmimg.cn/s23107/2019/10/11/3cf65a33efba914504.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 27009,
		"pack_cost": "0.00",
		"sales": 199446,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000092",
			"id": "82b0391c9f3e987f",
			"stock": "1000126.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/10/11/0093e8ec087a074edf.jpg",
			"num": 1,
			"price": 16,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 16,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/10/11/0093e8ec087a074edf.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "爆浆南瓜泥清甜不腻，麻薯Q弹有活力",
		"use_spec": false,
		"stock": "1000126.00",
		"type": 1,
		"is_label": 0,
		"name": "南瓜嘟嘟",
		"images": "https://img-shop.qmimg.cn/s23107/2019/10/11/0093e8ec087a074edf.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 27008,
		"pack_cost": "0.00",
		"sales": 158438,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000091",
			"id": "186191c7af8a25e2",
			"stock": "1000209.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/10/11/21bad4be51837450a8.jpg",
			"num": 1,
			"price": 16,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 16,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/10/11/21bad4be51837450a8.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "抹茶卡仕达表皮包裹着软糯红豆和绵密芋泥，拉丝麻薯糯唧唧",
		"use_spec": false,
		"stock": "1000209.00",
		"type": 1,
		"is_label": 0,
		"name": "红豆嘟嘟",
		"images": "https://img-shop.qmimg.cn/s23107/2019/10/11/21bad4be51837450a8.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 24516,
		"pack_cost": "0.00",
		"sales": 1278,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000070",
			"id": "5d79de67251ea00e",
			"stock": "10485.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/29/4a62ee45dd527609ed.jpg",
			"num": 1,
			"price": 18,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 18,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/29/4a62ee45dd527609ed.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "酥软口感,进口奶油搭配特制巧克力内馅",
		"use_spec": false,
		"stock": "10485.00",
		"type": 1,
		"is_label": 0,
		"name": "脏脏王",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/29/4a62ee45dd527609ed.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 24517,
		"pack_cost": "0.00",
		"sales": 1228,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000071",
			"id": "2b3f1ea3ecabd22e",
			"stock": "10308.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/29/99daa7b20061efab10.jpg",
			"num": 1,
			"price": 18,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 4,
		"price": 18,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/29/99daa7b20061efab10.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "精选北川半兵卫抹茶粉和秘制红豆泥",
		"use_spec": false,
		"stock": "10308.00",
		"type": 1,
		"is_label": 0,
		"name": "抹茶王",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/29/99daa7b20061efab10.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31834,
		"pack_cost": "0.00",
		"sales": 94527,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000003",
			"id": "c8d9d2828e1ff531",
			"stock": "1000108.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/28/d8e4330c48ae58c7da.jpg",
			"num": 1,
			"price": 15,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 7,
		"price": 15,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/28/d8e4330c48ae58c7da.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "梅菜扣肉咸香接地气，摊成薄薄饼状增大烘焙面积，撒上香烤的芝麻粒，特色风味独树一帜。",
		"use_spec": false,
		"stock": "1000108.00",
		"type": 1,
		"is_label": 0,
		"name": "梅菜肉肉",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/28/d8e4330c48ae58c7da.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31824,
		"pack_cost": "0.00",
		"sales": 143535,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000034",
			"id": "8996e12e46d28663",
			"stock": "10000237.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/05/05/30f0463b8b644e8417.jpg",
			"num": 1,
			"price": 18,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 8,
		"price": 18,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/05/05/30f0463b8b644e8417.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "柔软的表皮加上天然新鲜凤梨颗粒与安佳乳酪调制的凤梨果肉馅，每一口都酸甜可口，顺滑满足。",
		"use_spec": false,
		"stock": "10000237.00",
		"type": 1,
		"is_label": 0,
		"name": "芝士金凤梨",
		"images": "https://img-shop.qmimg.cn/s23107/2019/05/05/30f0463b8b644e8417.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31820,
		"pack_cost": "0.00",
		"sales": 123089,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000022",
			"id": "e06d86e3db130723",
			"stock": "10000198.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/28/8b123558614b56993d.jpg",
			"num": 1,
			"price": 14,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 9,
		"price": 14,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/28/8b123558614b56993d.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "柔软的欧包里藏着一整根脆皮肠，满口都是肉感，一口咸味一口浓郁奶味。",
		"use_spec": false,
		"stock": "10000198.00",
		"type": 1,
		"is_label": 0,
		"name": "德式腊肠犬",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/28/8b123558614b56993d.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31816,
		"pack_cost": "0.00",
		"sales": 223377,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000006",
			"id": "d10644f99c0313a4",
			"stock": "1000215.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/28/fc9ef3ae0338ad7b3a.jpg",
			"num": 1,
			"price": 29,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 10,
		"price": 29,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/28/fc9ef3ae0338ad7b3a.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "霸气的外表下包含着软绵甜蜜的榴莲果肉内陷。200度的烘烤热情，以及100分钟以上的制作工艺，这款纯手工软欧包给你大大的甜蜜和满足。",
		"use_spec": false,
		"stock": "1000215.00",
		"type": 1,
		"is_label": 0,
		"name": "一颗大榴莲",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/28/fc9ef3ae0338ad7b3a.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31814,
		"pack_cost": "0.00",
		"sales": 184270,
		"cover_img": "https://img-shop.qmimg.cn/s23107/2019/12/07/0476864cd0b7fd9bc4.jpg?imageView2/2/w/400/h/400",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000038",
			"id": "0c3cea3467da2817",
			"stock": "1000207.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/12/07/f0bc53b12b13f1df8d.jpg",
			"num": 1,
			"price": 23,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 11,
		"price": 23,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/12/07/f0bc53b12b13f1df8d.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "切碎的奶酪粒和香芋粒，味道清新，散发着奶酪和芋头的香气。奈雪非常独特的一款软欧包。",
		"use_spec": false,
		"stock": "1000207.00",
		"type": 1,
		"is_label": 0,
		"name": "奶酪芋头山",
		"images": "https://img-shop.qmimg.cn/s23107/2019/12/07/f0bc53b12b13f1df8d.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 16852,
		"pack_cost": "0.00",
		"sales": 225651,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000026",
			"id": "8e46d28edac152bd",
			"stock": "10435.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/28/417eae192c1dc8b9ab.jpg",
			"num": 1,
			"price": 18,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 18,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/28/417eae192c1dc8b9ab.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "菠菜汁入面团，咸香肉松甜脆玉米粒，咸口松软",
		"use_spec": false,
		"stock": "10435.00",
		"type": 1,
		"is_label": 0,
		"name": "菠菜肉骨头",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/28/417eae192c1dc8b9ab.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 17137,
		"pack_cost": "0.00",
		"sales": 232976,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000027",
			"id": "a43a6d40cef6f162",
			"stock": "10506.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/05/05/9979fa487e2c3e2636.jpg",
			"num": 1,
			"price": 15,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 4,
		"price": 15,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/05/05/9979fa487e2c3e2636.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "香甜浓郁的巧克力奶油与巧克力软欧包，夹着香脆的奥利奥饼干，一口又一口，停不下来。",
		"use_spec": false,
		"stock": "10506.00",
		"type": 1,
		"is_label": 0,
		"name": "奥利奥魔法棒",
		"images": "https://img-shop.qmimg.cn/s23107/2019/05/05/9979fa487e2c3e2636.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 17145,
		"pack_cost": "0.00",
		"sales": 173762,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000040",
			"id": "0f90fb60826f6fe0",
			"stock": "10332.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/05/05/a1202933e01235285a.jpg",
			"num": 1,
			"price": 20,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 5,
		"price": 20,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/05/05/a1202933e01235285a.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪招牌软欧包魔法棒家族之一，满满的新鲜水果看的见，软欧包有淡淡的胡萝卜味，芒果香味十分浓郁。",
		"use_spec": false,
		"stock": "10332.00",
		"type": 1,
		"is_label": 0,
		"name": "芒果魔法棒",
		"images": "https://img-shop.qmimg.cn/s23107/2019/05/05/a1202933e01235285a.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 16808,
		"pack_cost": "0.00",
		"sales": 115495,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000024",
			"id": "2e89b669b329c292",
			"stock": "10704.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/28/94d8440ab7b4fed802.jpg",
			"num": 1,
			"price": 20,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 5,
		"price": 20,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/28/94d8440ab7b4fed802.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "大大的一根魔法棒，加入淡奶油和进口酵母，配上经典的草莓鲜果。好看的外表和经典的口味造就的一款奈雪明星产品。",
		"use_spec": false,
		"stock": "10704.00",
		"type": 1,
		"is_label": 0,
		"name": "草莓魔法棒",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/28/94d8440ab7b4fed802.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 17138,
		"pack_cost": "0.00",
		"sales": 123169,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000012",
			"id": "c9bda650c3a9cb7f",
			"stock": "10138.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/05/05/cc722e14ae7c7973d9.jpg",
			"num": 1,
			"price": 15,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 15,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/05/05/cc722e14ae7c7973d9.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "摩卡味熊宝宝脸蛋，熊宝宝耳朵都有Q弹的金珠珠",
		"use_spec": false,
		"stock": "10138.00",
		"type": 1,
		"is_label": 0,
		"name": "奈雪熊宝宝",
		"images": "https://img-shop.qmimg.cn/s23107/2019/05/05/cc722e14ae7c7973d9.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "软欧包",
	"is_show_backstage": 0
}, {
	"sort": 9,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/28/bfeae4de9de15a0f88.png?imageView2/0/w/200/h/200",
	"id": 6510,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 57165,
		"pack_cost": "0.00",
		"sales": 9436,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000104",
			"id": "c860d6ad9cba0575",
			"stock": "999999947.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/19/08b868c6270203c344.jpg",
			"num": 1,
			"price": 16,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 16,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/19/08b868c6270203c344.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "无水工艺制作、只添加鸡蛋和牛奶，面包香味浓郁，口感细腻柔韧、嚼劲十足",
		"use_spec": false,
		"stock": "999999947.00",
		"type": 1,
		"is_label": 0,
		"name": "原味吐司",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/19/08b868c6270203c344.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 57167,
		"pack_cost": "0.00",
		"sales": 4746,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000106",
			"id": "d8820703d3bce4d1",
			"stock": "99999977.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/19/a7e10078ca8d48789f.jpg",
			"num": 1,
			"price": 23,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 23,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/19/a7e10078ca8d48789f.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "酥软外皮、自制香草风味卡仕达、颗粒饱满的柔软红豆，豆香四溢",
		"use_spec": false,
		"stock": "99999977.00",
		"type": 1,
		"is_label": 0,
		"name": "红豆千层吐司",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/19/a7e10078ca8d48789f.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 57166,
		"pack_cost": "0.00",
		"sales": 9967,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212000105",
			"id": "8ddfb6a43f25f987",
			"stock": "99999922.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/19/576288b90223ac24ae.jpg",
			"num": 1,
			"price": 22,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 22,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/19/576288b90223ac24ae.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "进口面粉揉制的面团，咸香四溢的肉松搭配自制Q弹麻薯",
		"use_spec": false,
		"stock": "99999922.00",
		"type": 1,
		"is_label": 0,
		"name": "肉松麻薯吐司",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/19/576288b90223ac24ae.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 25006,
		"pack_cost": "0.00",
		"sales": 12229,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212010005",
			"id": "fb4c7cf07b1d29cb",
			"stock": "10102.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/06/13/a74abd2b454461e7ed.jpg",
			"num": 1,
			"price": 9,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 1,
		"price": 9,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/06/13/a74abd2b454461e7ed.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "多种草莓元素汇集，打造专属咩咩包的粉红暴击；以草莓果酱特调淡奶油内馅，享受口腔里肆意的爆浆感，表面撒层酸甜草莓粉搭配草莓干颗粒与草莓巧克力薄层，果香萦绕，充满甜美气息。",
		"use_spec": false,
		"stock": "10102.00",
		"type": 1,
		"is_label": 0,
		"name": "草莓咩咩",
		"images": "https://img-shop.qmimg.cn/s23107/2019/06/13/a74abd2b454461e7ed.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 25003,
		"pack_cost": "0.00",
		"sales": 11608,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212010004",
			"id": "87302f460fa9d0f9",
			"stock": "10065.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/06/13/836219fa1162d1ab9c.jpg",
			"num": 1,
			"price": 9,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 1,
		"price": 9,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/06/13/836219fa1162d1ab9c.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "小羊角里加入巧克力味淡奶油内馅，表面撒层馥郁可可粉搭配黑巧爆谷米与黑巧克力薄层，多重巧克力风味，一口即享。",
		"use_spec": false,
		"stock": "10065.00",
		"type": 1,
		"is_label": 0,
		"name": "巧克力咩咩",
		"images": "https://img-shop.qmimg.cn/s23107/2019/06/13/836219fa1162d1ab9c.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 25001,
		"pack_cost": "0.00",
		"sales": 10548,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212010003",
			"id": "531b6d578cc1c18e",
			"stock": "10079.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/06/13/82804b3b87b2b57c44.jpg",
			"num": 1,
			"price": 9,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 1,
		"price": 9,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/06/13/82804b3b87b2b57c44.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "香浓抹茶，特调淡奶油内馅，并轻洒在表面一层薄薄的白巧克力上，成就颜值、内涵、口感的三重惊艳，抹茶控必入。",
		"use_spec": false,
		"stock": "10079.00",
		"type": 1,
		"is_label": 0,
		"name": "抹茶咩咩",
		"images": "https://img-shop.qmimg.cn/s23107/2019/06/13/82804b3b87b2b57c44.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 25000,
		"pack_cost": "0.00",
		"sales": 6233,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212010000",
			"id": "106c52ad2a01ffba",
			"stock": "10085.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/06/13/a3baf71549f038325d.jpg",
			"num": 1,
			"price": 9,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 1,
		"price": 9,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/06/13/a3baf71549f038325d.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "可爱玲珑的羊角个头，层层酥脆，一口咬下，卡士达淡奶油内馅爆浆感十足,表皮肉松海苔，带来更鲜脆风味",
		"use_spec": false,
		"stock": "10085.00",
		"type": 1,
		"is_label": 0,
		"name": "肉松咩咩",
		"images": "https://img-shop.qmimg.cn/s23107/2019/06/13/a3baf71549f038325d.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 68452,
		"pack_cost": "0.00",
		"sales": 741,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212020002",
			"id": "5efabb63696f2515",
			"stock": "99998.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/27/98f9e17936370f5c6e.jpg",
			"num": 1,
			"price": 10,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 10,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/27/98f9e17936370f5c6e.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "软酥蛋皮，奶香浓郁，布丁口感，外酥内嫩",
		"use_spec": false,
		"stock": "99998.00",
		"type": 1,
		"is_label": 0,
		"name": "经典蛋挞",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/27/98f9e17936370f5c6e.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 25011,
		"pack_cost": "0.00",
		"sales": 3268,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1298,
				"code": "Z5D5FA29D6070D7403",
				"value": "草莓咩咩"
			}, {
				"is_default": 0,
				"id": 1299,
				"code": "Z5D5FA29D60DAE4347",
				"value": "巧克力咩咩"
			}, {
				"is_default": 0,
				"id": 1300,
				"code": "Z5D5FA29D614794268",
				"value": "抹茶咩咩"
			}, {
				"is_default": 0,
				"id": 1302,
				"code": "Z5D5FA29D6221E9709",
				"value": "肉松咩咩"
			}],
			"name": "选择一",
			"id": 262
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1303,
				"code": "Z5D5FA29D62C482120",
				"value": "草莓咩咩"
			}, {
				"is_default": 0,
				"id": 1305,
				"code": "Z5D5FA29D63A198780",
				"value": "抹茶咩咩"
			}, {
				"is_default": 0,
				"id": 1306,
				"code": "Z5D5FA29D642F31535",
				"value": "巧克力咩咩"
			}, {
				"is_default": 0,
				"id": 1308,
				"code": "Z5D5FA29D6518E8070",
				"value": "肉松咩咩"
			}],
			"name": "选择二",
			"id": 263
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1309,
				"code": "Z5D5FA29D65F0C3220",
				"value": "肉松咩咩"
			}, {
				"is_default": 0,
				"id": 1311,
				"code": "Z5D5FA29D66BAB8787",
				"value": "巧克力咩咩"
			}, {
				"is_default": 0,
				"id": 1312,
				"code": "Z5D5FA29D672AF9110",
				"value": "草莓咩咩"
			}, {
				"is_default": 0,
				"id": 1313,
				"code": "Z5D5FA29D6794A2665",
				"value": "抹茶咩咩"
			}],
			"name": "选择三",
			"id": 366
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "11110015",
			"id": "2693ad8a72f32fdf",
			"stock": "100000080.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/06/13/b92a9d35a43e67ceab.jpg",
			"num": 1,
			"price": 24,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 24,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/06/13/b92a9d35a43e67ceab.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "#一口酥脆-满口爆浆的咩咩包#来啦！奈雪首次推出咩咩包系列，六个口味荟萃，任选三只即享优惠组合价~层层酥脆，让美味与分享同在~",
		"use_spec": false,
		"stock": "100000080.00",
		"type": 1,
		"is_label": 0,
		"name": "咩咩包组合装",
		"images": "https://img-shop.qmimg.cn/s23107/2019/06/13/b92a9d35a43e67ceab.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "手作烘焙",
	"is_show_backstage": 0
}, {
	"sort": 12,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/28/edd969e6c892853667.png?imageView2/0/w/200/h/200",
	"id": 2497,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 58708,
		"pack_cost": "0.00",
		"sales": 11519,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E7C5F8A51A546188",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 609,
				"code": "Z5E7C5F8A51F7E8021",
				"value": "少冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E7C5F8A523892538",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E7C5F8A527A67945",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E7C5F8A52B737106",
				"value": "温"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5E7C5F8A5340E8233",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5E7C5F8A538459155",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 610,
				"code": "Z5E7C5F8A53C5A7778",
				"value": "微糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5E7C5F8A540DF9794",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010000008",
			"id": "5117d6934f984ddd",
			"stock": "999999825.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/26/fcece4bb6af2673e37.jpg",
			"num": 1,
			"price": 19,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 19,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/26/fcece4bb6af2673e37.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "精选金观音茶叶，汤色金黄清澈、香气馥郁幽长，搭配奈雪芝士奶盖，回甘醇厚。",
		"use_spec": false,
		"stock": "999999825.00",
		"type": 1,
		"is_label": 0,
		"name": "芝士金观音",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/26/fcece4bb6af2673e37.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31558,
		"pack_cost": "0.00",
		"sales": 37172,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2CF50F4767076",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2CF50F8B97969",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2CF50FC797077",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2CF51003F7078",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD783C1026547401",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD783C1029E21469",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD783C102D7B3883",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010000003",
			"id": "a2b1def8331cd4c4",
			"stock": "99999752.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/27/369520a40d39e0ac11.jpg",
			"num": 1,
			"price": 21,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 21,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/27/369520a40d39e0ac11.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "热饮为纸杯包装，茉莉花的香气和绿茶的清新融合，汤色清亮",
		"use_spec": false,
		"stock": "99999752.00",
		"type": 1,
		"is_label": 0,
		"name": "芝士茉莉初雪",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/27/369520a40d39e0ac11.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31560,
		"pack_cost": "0.00",
		"sales": 17293,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2D16A308C7944",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2D16A34E74683",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2D16A38D21680",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2D16A3D2B4114",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD7820B13E2F5968",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD7820B141B57300",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD7820B145611482",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010000002",
			"id": "f213dedd5653800c",
			"stock": "10000077.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/27/bac6a6e8b23fd3b30e.jpg",
			"num": 1,
			"price": 22,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 22,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/27/bac6a6e8b23fd3b30e.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪定制茶。选用武夷山金骏眉等三种名优红茶调配而成，有独特的烟熏龙眼木香气，搭配轻盈香滑的芝士奶盖，中和淡淡涩口。",
		"use_spec": false,
		"stock": "10000077.00",
		"type": 1,
		"is_label": 0,
		"name": "芝士奈雪金色山脉",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/27/bac6a6e8b23fd3b30e.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31557,
		"pack_cost": "0.00",
		"sales": 35462,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2CE34D0EA6729",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2CE34D6612524",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2CE34DAE75885",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2CE34F6D97845",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD783375B6983153",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD783375BA6C4391",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD783375BE198735",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010000001",
			"id": "9e63c54d02eec86b",
			"stock": "10000137.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/27/8d4a1edb7c9e2d6554.jpg",
			"num": 1,
			"price": 22,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 22,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/27/8d4a1edb7c9e2d6554.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪名优茶。荣获2018年台湾冬茶比赛头等奖。茶山沾染的花香气、低温烘焙的醇甜香，入口回甘。搭配轻盈香滑的咸芝士奶盖，中和淡淡涩口。",
		"use_spec": false,
		"stock": "10000137.00",
		"type": 1,
		"is_label": 0,
		"name": "芝士奈雪初露",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/27/8d4a1edb7c9e2d6554.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "芝士茗优茶",
	"is_show_backstage": 0
}, {
	"sort": 14,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/28/33fe4d0f9c3b8b7b97.png?imageView2/0/w/200/h/200",
	"id": 2500,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 58710,
		"pack_cost": "0.00",
		"sales": 6064,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E7C60433E1E03482",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 609,
				"code": "Z5E7C60433E6B51206",
				"value": "少冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E7C60433EAB73816",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E7C60433EE769255",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E7C60433F22E8316",
				"value": "温"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5E7C60433FA1A6064",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5E7C60433FEA91288",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 610,
				"code": "Z5E7C60434031C3451",
				"value": "微糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5E7C6043407752183",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010030008",
			"id": "1a5ad9d3d03883ad",
			"stock": "999999524.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/16/a169f730488a724acc.jpg",
			"num": 1,
			"price": 13,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 13,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/16/a169f730488a724acc.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "精选金观音茶叶，汤色金黄清澈、香气馥郁幽长",
		"use_spec": false,
		"stock": "999999524.00",
		"type": 1,
		"is_label": 0,
		"name": "金观音",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/16/a169f730488a724acc.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31431,
		"pack_cost": "0.00",
		"sales": 8582,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2D39B2E2C1515",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2D39B32726459",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 609,
				"code": "Z5E5E2D39B362B1790",
				"value": "少冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2D39B39E09251",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2D39B3D864768",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD7835D198C73695",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD7835D19C263883",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD7835D19F993256",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010030003",
			"id": "489fc9c35ba35792",
			"stock": "998479.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/27/0491350e8dca665627.jpg",
			"num": 1,
			"price": 15,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 4,
		"price": 15,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/27/0491350e8dca665627.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "热饮为纸杯包装，茉莉花的香气和绿茶的清新融合，汤色清亮",
		"use_spec": false,
		"stock": "998479.00",
		"type": 1,
		"is_label": 0,
		"name": "茉莉初雪",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/27/0491350e8dca665627.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31433,
		"pack_cost": "0.00",
		"sales": 2696,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2D59A10614619",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2D59A15915459",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2D59A19D98802",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2D59A1E4D5205",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD7880C6EA1B9131",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD7880C6EDDD5553",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD7880C6F1A92100",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010030001",
			"id": "baa902a28fef5352",
			"stock": "999794.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/27/dfbf560ac141c88213.jpg",
			"num": 1,
			"price": 16,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 16,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/27/dfbf560ac141c88213.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪定制茶,选用武夷山金骏眉等三种名优红茶调配而成，独特的烟熏龙眼木香气，甘醇韵长回味无穷。",
		"use_spec": false,
		"stock": "999794.00",
		"type": 1,
		"is_label": 0,
		"name": "奈雪金色山脉",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/27/dfbf560ac141c88213.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31430,
		"pack_cost": "0.00",
		"sales": 4297,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2D291B76F7651",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2D291BBF32291",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2D291BFE24955",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2D291C4752910",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD782A24282D3131",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD782A242C053219",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD782A2430ED6328",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010030000",
			"id": "e86191ffd2a27a25",
			"stock": "99430.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/27/7d0a4993b5926e2bc6.jpg",
			"num": 1,
			"price": 16,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 16,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/27/7d0a4993b5926e2bc6.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪名优茶。荣获2017年台湾冬茶比赛头等奖。清新的花香气、低温烘焙的醇甜香，入口5秒等待回甘。",
		"use_spec": false,
		"stock": "99430.00",
		"type": 1,
		"is_label": 0,
		"name": "奈雪初露",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/27/7d0a4993b5926e2bc6.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 16719,
		"pack_cost": "0.00",
		"sales": 14868,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "793:3068|794:3063",
			"trade_mark": "1010020000",
			"id": "2728bc1fd96b4d6a",
			"stock": "9914.00",
			"spec_text": {
				"温度": "冷",
				"糖度": "无糖"
			},
			"spec": {
				"793": 3068,
				"794": 3063
			},
			"image": "s23107/2019/04/26/3afbe376457c893497.jpg",
			"num": 1,
			"price": 22,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 22,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/3afbe376457c893497.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [{
			"values": [{
				"id": 3068,
				"image": null,
				"value": "冷"
			}],
			"name": "温度",
			"id": 793
		}, {
			"values": [{
				"id": 3063,
				"image": null,
				"value": "无糖"
			}],
			"name": "糖度",
			"id": 794
		}],
		"content": "奈雪名优茶。严选台湾阿里山优质冻顶乌龙茶，低温冷泡8小时，减少咖啡因释放，降低涩味，茶香更甘醇",
		"use_spec": true,
		"stock": "9914.00",
		"type": 1,
		"is_label": 0,
		"name": "冻顶乌龙(冷泡茶)",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/3afbe376457c893497.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 16718,
		"pack_cost": "0.00",
		"sales": 14692,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "793:3068|794:3063",
			"trade_mark": "1010020001",
			"id": "6334b219fa565cc3",
			"stock": "9888.00",
			"spec_text": {
				"温度": "冷",
				"糖度": "无糖"
			},
			"spec": {
				"793": 3068,
				"794": 3063
			},
			"image": "s23107/2019/04/26/f8e25f045c19df333d.jpg",
			"num": 1,
			"price": 22,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 22,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/f8e25f045c19df333d.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [{
			"values": [{
				"id": 3068,
				"image": null,
				"value": "冷"
			}],
			"name": "温度",
			"id": 793
		}, {
			"values": [{
				"id": 3063,
				"image": null,
				"value": "无糖"
			}],
			"name": "糖度",
			"id": 794
		}],
		"content": "来自台湾阿里山的乌龙茶，生长于终年云雾缭绕之地，作为正大名茶的特有品种，甘甜带果胶质口感是其独特魅力。花香气清雅，滋味清醇甘甜",
		"use_spec": true,
		"stock": "9888.00",
		"type": 1,
		"is_label": 0,
		"name": "青心乌龙(冷泡茶)",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/f8e25f045c19df333d.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "无糖茶铺",
	"is_show_backstage": 0
}, {
	"sort": 15,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/28/6557447a5b85a3bf71.png?imageView2/0/w/200/h/200",
	"id": 2488,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 31535,
		"pack_cost": "0.00",
		"sales": 18309,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2BE2B23BB3413",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2BE2B27F03307",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2BE2B2D002260",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2BE2B30842522",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78350A14958747",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD78350A18165102",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD78350A1C237554",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010090003",
			"id": "286cf6b1bc6dedbd",
			"stock": "1000020.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/612997e450b52ba186.jpg",
			"num": 1,
			"price": 24,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 24,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/612997e450b52ba186.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "精选阿拉比卡咖啡豆与冻顶乌龙茶结合，质感幼滑不苦涩，入口香醇，推荐热饮更好喝。",
		"use_spec": false,
		"stock": "1000020.00",
		"type": 1,
		"is_label": 0,
		"name": "大咖鸳鸯",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/612997e450b52ba186.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 65309,
		"pack_cost": "0.00",
		"sales": 439,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E952C509B5561077",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E952C509BA997660",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E952C509BE6A2251",
				"value": "热"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 1959,
				"code": "Z5E952C509C5816724",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010090008",
			"id": "c88ebf2110c0a219",
			"stock": "9999955.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/16/48279ebcd71456ac25.jpg",
			"num": 1,
			"price": 19,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 19,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/16/48279ebcd71456ac25.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪拿铁",
		"use_spec": false,
		"stock": "9999955.00",
		"type": 1,
		"is_label": 0,
		"name": "奈雪拿铁",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/16/48279ebcd71456ac25.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 65307,
		"pack_cost": "0.00",
		"sales": 382,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E952A913A5C51731",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E952A913ADE83916",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E952A913B1955053",
				"value": "热"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 1959,
				"code": "Z5E952A913B8711256",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010090007",
			"id": "08a06c749c6f0c91",
			"stock": "9999965.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/16/456b9428f57f11fc93.jpg",
			"num": 1,
			"price": 13,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 13,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/16/456b9428f57f11fc93.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪美式",
		"use_spec": false,
		"stock": "9999965.00",
		"type": 1,
		"is_label": 0,
		"name": "奈雪美式",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/16/456b9428f57f11fc93.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31534,
		"pack_cost": "0.00",
		"sales": 12285,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5D5E3D4D809A35120",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5D5E3D4D80ED58634",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD783E4E22621019",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD783E4E26093700",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD783E4E29D68842",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010090001",
			"id": "80b1c59b6bf77b0f",
			"stock": "9999954.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/05/05/2d77f4daaabc3144b2.jpg",
			"num": 1,
			"price": 19,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 1,
		"price": 19,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/05/05/2d77f4daaabc3144b2.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "咖啡与鲜果茶的创新组合，精心挑选拥有更多香甜因子的翡翠柠檬，柠檬的清爽与咖啡的香醇相结合，唇齿留香。",
		"use_spec": false,
		"stock": "9999954.00",
		"type": 1,
		"is_label": 0,
		"name": "大咖柠檬",
		"images": "https://img-shop.qmimg.cn/s23107/2019/05/05/2d77f4daaabc3144b2.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31429,
		"pack_cost": "0.00",
		"sales": 3346,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1219,
				"code": "Z5DEDBF956E3931146",
				"value": "标准(冰淇淋+水晶)"
			}, {
				"is_default": 0,
				"id": 1220,
				"code": "Z5DEDBF956E7728487",
				"value": "无配料"
			}, {
				"is_default": 0,
				"id": 1257,
				"code": "Z5DEDBF956EAC25859",
				"value": "去水晶"
			}, {
				"is_default": 0,
				"id": 2066,
				"code": "Z5DEDBF956EEC87411",
				"value": "去冰淇淋"
			}, {
				"is_default": 0,
				"id": 2067,
				"code": "Z5DEDBF956F2404144",
				"value": "换香草冰淇淋"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1167,
				"code": "Z5D676D0DB876D9109",
				"value": "标准（冰沙）"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD782B18BE101476",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD782B18C1A57165",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD782B18C4EE8451",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010090005",
			"id": "10ba24d03b9fc7fe",
			"stock": "10000147.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/776ccac30466e6bd52.jpg",
			"num": 1,
			"price": 34,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 34,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/776ccac30466e6bd52.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "以现萃咖啡融合茉莉绿茶，加入牛油果、椰子冰淇淋及水晶冻。口感细腻，一口能喝到三重味道，金杯华丽亮相，能量满满。",
		"use_spec": false,
		"stock": "10000147.00",
		"type": 1,
		"is_label": 0,
		"name": "大咖牛油果",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/776ccac30466e6bd52.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "咖啡",
	"is_show_backstage": 0
}, {
	"sort": 18,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/28/6557447a5b85a3bf71.png?imageView2/0/w/200/h/200",
	"id": 4365,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 38230,
		"pack_cost": "0.00",
		"sales": 52072,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1313030018",
			"id": "2a8c5a1d486e1e82",
			"stock": "9999999911.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/11/01/bb339b1b5c2f6fdac4.jpg",
			"num": 1,
			"price": 2,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 2,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/11/01/bb339b1b5c2f6fdac4.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "可用于2杯饮品打包使用（保温袋会不定期更换插画图片，以门店正在使用的为准）",
		"use_spec": false,
		"stock": "9999999911.00",
		"type": 1,
		"is_label": 0,
		"name": "小保温袋",
		"images": "https://img-shop.qmimg.cn/s23107/2019/11/01/bb339b1b5c2f6fdac4.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 38229,
		"pack_cost": "0.00",
		"sales": 16211,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1313030019",
			"id": "591339726df9791b",
			"stock": "999999966.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/11/01/9ea7b5249a2f11a1a1.jpg",
			"num": 1,
			"price": 4,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 4,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/11/01/9ea7b5249a2f11a1a1.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "可用于4杯饮品打包使用（保温袋会不定期更换插画图片，以门店正在使用的为准）",
		"use_spec": false,
		"stock": "999999966.00",
		"type": 1,
		"is_label": 0,
		"name": "大保温袋",
		"images": "https://img-shop.qmimg.cn/s23107/2019/11/01/9ea7b5249a2f11a1a1.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "保温加购",
	"is_show_backstage": 0
}, {
	"sort": 40,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/30/458c5a14fb2f190f96.png?imageView2/0/w/200/h/200",
	"id": 5658,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 52969,
		"pack_cost": "0.00",
		"sales": 27,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "",
			"id": "1f58bd9127939f42",
			"stock": "999.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/02/23/28e175507553571969.jpeg",
			"num": 1,
			"price": 0,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 0,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/02/23/28e175507553571969.jpeg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "推荐使用奈雪点单小程序下单，降低接触频次。",
		"use_spec": false,
		"stock": "999.00",
		"type": 4,
		"is_label": 0,
		"name": "在线下单",
		"images": "https://img-shop.qmimg.cn/s23107/2020/02/23/28e175507553571969.jpeg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 52968,
		"pack_cost": "0.00",
		"sales": 69,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "",
			"id": "ec3ab81ec6c17f95",
			"stock": "999.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/02/23/17fe4ee12651c84667.jpeg",
			"num": 1,
			"price": 0,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 0,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/02/23/17fe4ee12651c84667.jpeg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "面包柜内所有面包进行装袋或者装盒陈列售卖。",
		"use_spec": false,
		"stock": "999.00",
		"type": 4,
		"is_label": 0,
		"name": "面包装袋",
		"images": "https://img-shop.qmimg.cn/s23107/2020/02/23/17fe4ee12651c84667.jpeg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 52967,
		"pack_cost": "0.00",
		"sales": 77,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "",
			"id": "b027d6132eff660d",
			"stock": "999.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/02/23/28e11fa60c3c7b952f.jpeg",
			"num": 1,
			"price": 0,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 0,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/02/23/28e11fa60c3c7b952f.jpeg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "堂食打包和外卖均提供安心卡，将茶饮制作、面包制作、配餐员以及骑手姓名记录并做好体温测量。做到食品安全可追踪、制作及配送可追踪，请您安心用餐。",
		"use_spec": false,
		"stock": "999.00",
		"type": 4,
		"is_label": 0,
		"name": "安心卡片",
		"images": "https://img-shop.qmimg.cn/s23107/2020/02/23/28e11fa60c3c7b952f.jpeg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 52966,
		"pack_cost": "0.00",
		"sales": 66,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "",
			"id": "7aecf3d9c78a4306",
			"stock": "999.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/02/23/5761fbd2344ef96307.jpeg",
			"num": 1,
			"price": 0,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 0,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/02/23/5761fbd2344ef96307.jpeg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "1. 门店伙伴严格执行每小时1次洗手消毒。2. 门店伙伴上岗前进行体温检测。3. 就餐桌椅以及工作台面每小时清洁1次，再用消毒液进行消毒。4. 与食品接触的所有设备、器具、毛巾等严格执行清洁及消毒工作。5. 门店顾客入口处，提供消毒凝胶进行手部消毒。",
		"use_spec": false,
		"stock": "999.00",
		"type": 4,
		"is_label": 0,
		"name": "门店防疫",
		"images": "https://img-shop.qmimg.cn/s23107/2020/02/23/5761fbd2344ef96307.jpeg?imageView2/2/w/400/h/400"
	}],
	"name": "共同防疫",
	"is_show_backstage": 0
}, {
	"sort": 41,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/30/458c5a14fb2f190f96.png?imageView2/0/w/200/h/200",
	"id": 5659,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 52965,
		"pack_cost": "0.00",
		"sales": 2,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "",
			"id": "7acc73c0f76a45b3",
			"stock": "999.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/02/22/81748e7805a82c0e9d.png",
			"num": 1,
			"price": 0,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 0,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/02/22/81748e7805a82c0e9d.png?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "即日起，奈雪支持企业团餐订购啦，全程使用无接触配送，让您饮茶食包更安心\n企业团餐50份起送（包含茶饮和欧包），可根据您的需求按时送达指定位置，为了让您可以准时收到餐食，建议您提前一天订购，更多订购详情可添加团餐客服微信咨询（微信号：nx-digital）",
		"use_spec": false,
		"stock": "999.00",
		"type": 4,
		"is_label": 0,
		"name": "企业团餐",
		"images": "https://img-shop.qmimg.cn/s23107/2020/02/22/81748e7805a82c0e9d.png?imageView2/2/w/400/h/400"
	}],
	"name": "企业团餐",
	"is_show_backstage": 0
}, {
	"sort": 79,
	"icon": "",
	"id": 6806,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 65305,
		"pack_cost": "0.00",
		"sales": 213,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212040003",
			"id": "341052a7d635e243",
			"stock": "99999985.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/16/24d94bd8d1517503e1.jpg",
			"num": 1,
			"price": 16,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 16,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/16/24d94bd8d1517503e1.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "特制的STARFIELD 植物肉、酸黄瓜片、紫甘蓝，沙拉酱",
		"use_spec": false,
		"stock": "99999985.00",
		"type": 1,
		"is_label": 0,
		"name": "黑椒植物肉三明治",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/16/24d94bd8d1517503e1.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 65302,
		"pack_cost": "0.00",
		"sales": 418,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212040002",
			"id": "0a6d3607987f3666",
			"stock": "999999965.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/16/20cfe8e412a87e5cbe.jpg",
			"num": 1,
			"price": 16,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 16,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/16/20cfe8e412a87e5cbe.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "厚实秘制精致腿排、新鲜切丝紫甘蓝、淋上香甜的沙拉酱、口感层次分明；",
		"use_spec": false,
		"stock": "999999965.00",
		"type": 1,
		"is_label": 0,
		"name": "蜜汁鸡腿肉三明治",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/16/20cfe8e412a87e5cbe.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 65300,
		"pack_cost": "0.00",
		"sales": 480,
		"cover_img": "",
		"property": [],
		"is_sell": true,
		"goods_type": 1,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1212040001",
			"id": "304b27c0e45f3e1c",
			"stock": "99999967.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/16/62f2aa82f406097c6e.jpg",
			"num": 1,
			"price": 12,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 12,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/16/62f2aa82f406097c6e.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 0,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "金黄松软吐司片，铺上特制土豆馅、芝士片和鸡蛋，再挤入香甜的沙拉酱；",
		"use_spec": false,
		"stock": "99999967.00",
		"type": 1,
		"is_label": 0,
		"name": "土豆芝士蛋三明治",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/16/62f2aa82f406097c6e.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "三明治",
	"is_show_backstage": 0
}, {
	"sort": 4,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/28/949ba26d52c601c007.png?imageView2/0/w/200/h/200",
	"id": 2469,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 31532,
		"pack_cost": "0.00",
		"sales": 5104,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1218,
				"code": "Z5D612C34C8EF06658",
				"value": "标准(芝士)"
			}, {
				"is_default": 0,
				"id": 1166,
				"code": "Z5D612C34C93705460",
				"value": "芝士换酸奶"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5EA8DBDA4371C5994",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 1164,
				"code": "Z5EA8DBDA43C415239",
				"value": "冰沙"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5EA8DBDA4404E3515",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78286916115856",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD78286919682277",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD7828691CB89112",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010050008",
			"id": "f8114313a48c5c4a",
			"stock": "1000314.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/19/a3ee1fa72435259a73.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 4,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/19/a3ee1fa72435259a73.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "精选优质巨峰葡萄、手工去皮去籽、加入带兰桂花香，经中度焙火的金观音茶中，搭配轻盈香甜芝士奶盖",
		"use_spec": false,
		"stock": "1000314.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气芝士葡萄",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/19/a3ee1fa72435259a73.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31425,
		"pack_cost": "0.00",
		"sales": 166533,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1218,
				"code": "Z5D5BA41448F494221",
				"value": "标准(芝士)"
			}, {
				"is_default": 0,
				"id": 1166,
				"code": "Z5D5BA4144931C2200",
				"value": "芝士换酸奶"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1164,
				"code": "Z5D5BA414499AC5454",
				"value": "冰沙"
			}, {
				"is_default": 0,
				"id": 582,
				"code": "Z5D5BA41449D321738",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5D5BA4144A0C19680",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78377493B92481",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD783774971F6671",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD7837749AA21326",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010050001",
			"id": "be5afa4e3fa70cd7",
			"stock": "10001214.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/a2aad6ced9aa42e2c6.jpg",
			"num": 1,
			"price": 29,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 29,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/a2aad6ced9aa42e2c6.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪人气产品。选用优质台芒，搭配严选茉莉毛尖茶底，淋上轻盈香滑的芝士奶盖。",
		"use_spec": false,
		"stock": "10001214.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气芝士芒果",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/a2aad6ced9aa42e2c6.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31424,
		"pack_cost": "0.00",
		"sales": 125010,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1218,
				"code": "Z5D5BA2BB31A145049",
				"value": "标准(芝士)"
			}, {
				"is_default": 0,
				"id": 1166,
				"code": "Z5D5BA2BB320FA8410",
				"value": "芝士换酸奶"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 0,
				"id": 582,
				"code": "Z5E5E2BC316DD78061",
				"value": "标准冰"
			}, {
				"is_default": 1,
				"id": 1164,
				"code": "Z5E5E2BC316A215600",
				"value": "冰沙"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2BC3171CA8287",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2BC317A175989",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2BC317F896724",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD785286B9689681",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD785286BCF74540",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD785286C0687027",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010050003",
			"id": "ee375ed5ae7f77eb",
			"stock": "1002053.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/1cb88e6cd2fbcefb2a.jpg",
			"num": 1,
			"price": 29,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 29,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/1cb88e6cd2fbcefb2a.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪明星产品。选用奈雪自有草莓园新鲜草莓，搭配严选茉莉毛尖茶底，淋上轻盈香滑的芝士奶盖。",
		"use_spec": false,
		"stock": "1002053.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气芝士草莓",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/1cb88e6cd2fbcefb2a.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31531,
		"pack_cost": "0.00",
		"sales": 94538,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1218,
				"code": "Z5D612BDE5B8BE7438",
				"value": "标准(芝士)"
			}, {
				"is_default": 0,
				"id": 1166,
				"code": "Z5D612BDE5BEB01741",
				"value": "芝士换酸奶"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1164,
				"code": "Z5D5E3AAD448821800",
				"value": "冰沙"
			}, {
				"is_default": 0,
				"id": 582,
				"code": "Z5D5E3AAD44E888614",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5D5E3AAD453387851",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78801915838939",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD788019191B8084",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD7880191CD17624",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010050002",
			"id": "4a2db30bedfd6604",
			"stock": "1001167.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/e4cace0c07eb44e96f.jpg",
			"num": 1,
			"price": 33,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 100,
		"price": 33,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/e4cace0c07eb44e96f.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "草莓、蓝莓、树莓，三种莓果混合搭配，与茉莉毛尖一拍即合，清爽甘醇的茶香搭配浓郁果香，几重滋味在口腔里面碰撞，留下余味。",
		"use_spec": false,
		"stock": "1001167.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气芝士莓莓莓",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/e4cace0c07eb44e96f.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "霸气芝士鲜果茶",
	"is_show_backstage": 0
}, {
	"sort": 5,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/28/d95284dc7e745f8198.png?imageView2/0/w/200/h/200",
	"id": 2468,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 68339,
		"pack_cost": "0.00",
		"sales": 44429,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5EA54C3D0E4279185",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5EA54C3D0E9682750",
				"value": "去冰"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5EA54C3D0F2A37322",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5EA54C3D0F70A1000",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5EA54C3D0FAFE7320",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010025",
			"id": "72cf1279c0a422ce",
			"stock": "9999817.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/26/559a075d81060b23c7.jpg",
			"num": 1,
			"price": 30,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 0,
		"price": 30,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/26/559a075d81060b23c7.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "饱满大颗的新鲜杨梅,满杯手工去核,搭配茉莉初雪茶底,清爽多汁",
		"use_spec": false,
		"stock": "9999817.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气杨梅",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/26/559a075d81060b23c7.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31419,
		"pack_cost": "0.00",
		"sales": 63830,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2B67CF2CD2014",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2B67CF7386076",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2B67CFC6C7297",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2B67CFFFC6344",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78A6BAB6A96008",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD78A6BAB9F81083",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD78A6BABD425411",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010006",
			"id": "7ddf70f3db56c238",
			"stock": "9999416.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/3bef9469d37eac7b06.jpg",
			"num": 1,
			"price": 17,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 1,
		"price": 17,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/3bef9469d37eac7b06.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "精心挑选拥有更多香甜因子的翡翠柠檬，清爽水灵遇上金色山脉独特的龙眼木香气，更加醇厚。",
		"use_spec": false,
		"stock": "9999416.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气黄柠檬",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/3bef9469d37eac7b06.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 68345,
		"pack_cost": "0.00",
		"sales": 16322,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5EA55088766CC7824",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5EA5508876F271659",
				"value": "去冰"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5EA55088776843559",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5EA5508877A528469",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5EA5508877E5A6908",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010043",
			"id": "c7c6f8fd34040338",
			"stock": "999950.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/26/ea8fc439fddf2f62e3.jpg",
			"num": 1,
			"price": 32,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 32,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/26/ea8fc439fddf2f62e3.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "霸气杨梅和酸奶的首次搭配,甘甜可口",
		"use_spec": false,
		"stock": "999950.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气酸奶杨梅",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/26/ea8fc439fddf2f62e3.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31507,
		"pack_cost": "0.00",
		"sales": 199583,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2B483FA903805",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2B484016A8529",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2B48405642832",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2B48409616050",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD789B45391F4495",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD789B453D023182",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD789B4540531795",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010000",
			"id": "097aad038aeeb0ea",
			"stock": "998101.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/2a4b2697bec6f7e502.jpg",
			"num": 1,
			"price": 25,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 25,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/2a4b2697bec6f7e502.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪明星产品。优选进口新奇士橙，搭配严选茉莉毛尖茶底，橙意满满。",
		"use_spec": false,
		"stock": "998101.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气橙子",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/2a4b2697bec6f7e502.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31420,
		"pack_cost": "0.00",
		"sales": 79330,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2B85F17929383",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2B85F1F1B3653",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2B85F22FD7672",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2B85F26FF5081",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78A4713C675763",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD78A471400C9869",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD78A47143654620",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010004",
			"id": "944078205e237f86",
			"stock": "9999096.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/333b43719bd81f4e00.jpg",
			"num": 1,
			"price": 17,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 17,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/333b43719bd81f4e00.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "茉莉毛尖与绿柠檬的鲜活组合，清新馥郁的茶香跟柠檬的酸度契合，口感纯净清爽至佳",
		"use_spec": false,
		"stock": "9999096.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气绿柠檬",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/333b43719bd81f4e00.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 34254,
		"pack_cost": "0.00",
		"sales": 44115,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5D833EF2826151137",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5D833EF282A7E7293",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD7812AC5BC04098",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD7812AC5FA38677",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD7812AC64CA3721",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010013",
			"id": "39d4a2ea969474ff",
			"stock": "998178.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/09/19/b188394541d392d995.jpg",
			"num": 1,
			"price": 19,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 19,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/09/19/b188394541d392d995.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "选用上等茉莉毛尖茶底，纯手工捣碎的百香果，每口都可以喝到满满果肉，浓郁果香中带些酸涩，加入益力多，中和甜味。",
		"use_spec": false,
		"stock": "998178.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气百香多多",
		"images": "https://img-shop.qmimg.cn/s23107/2019/09/19/b188394541d392d995.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31421,
		"pack_cost": "0.00",
		"sales": 140108,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E5E2B96160502300",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2B96165206954",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E5E2B961691F4378",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2B9616D5F6916",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78A1C4BBDA9758",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD78A1C4BF943434",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD78A1C4C30F7434",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010012",
			"id": "eeb6099df6c2643b",
			"stock": "999465.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/e467b3c4e665cddc13.jpg",
			"num": 1,
			"price": 23,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 4,
		"price": 23,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/e467b3c4e665cddc13.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "茉莉毛尖茶底，带有花茶特有的香气，加入鲜榨西柚，果粒饱满。西柚糖分较少，搭配茶底清甜爽口。",
		"use_spec": false,
		"stock": "999465.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气西柚",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/e467b3c4e665cddc13.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31730,
		"pack_cost": "0.00",
		"sales": 1805,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 0,
				"id": 582,
				"code": "Z5EA8DC2C386039619",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 1164,
				"code": "Z5EA8DC2C38BE59577",
				"value": "冰沙"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5EA8DC2C390672147",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD7807C553AA1993",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD7807C557CF4823",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD7807C55B668276",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010024",
			"id": "7d95b01dd69ee729",
			"stock": "999783.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/03/19/630a810c8c7201c112.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 6,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/03/19/630a810c8c7201c112.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "精选优质巨峰葡萄、手工去皮去籽、加入带兰桂花香，经中度焙火的金观音茶中",
		"use_spec": false,
		"stock": "999783.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气葡萄",
		"images": "https://img-shop.qmimg.cn/s23107/2020/03/19/630a810c8c7201c112.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31508,
		"pack_cost": "0.00",
		"sales": 42335,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5D5D4D6F36ABC7392",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5D5D4D6F36F1C6105",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD789E36A0574960",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD789E36A5477015",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD789E36A9581059",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010080001",
			"id": "ab099692d7651ce7",
			"stock": "10000130.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/af2554d89e755030c3.jpg",
			"num": 1,
			"price": 29,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 29,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/af2554d89e755030c3.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "霸气橙子遇见两株美国益生菌种，助力代谢，促进肠道运动，减少热量吸收。",
		"use_spec": false,
		"stock": "10000130.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气燃爆橙子",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/af2554d89e755030c3.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31423,
		"pack_cost": "0.00",
		"sales": 63159,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1164,
				"code": "Z5D5BA1994227C7642",
				"value": "冰沙"
			}, {
				"is_default": 0,
				"id": 582,
				"code": "Z5D5BA199426BD5154",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5D5BA19942A0C6428",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78A9530CD61996",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD78A95310979784",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD78A953141D8332",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010002",
			"id": "01ae17591f05925d",
			"stock": "10000487.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/59b1ee7e3109933ef2.jpg",
			"num": 1,
			"price": 29,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 29,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/59b1ee7e3109933ef2.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "选用优质台芒，满满果肉打碎，搭配严选茉莉毛尖茶底，每一口都有热带芒果的香气。",
		"use_spec": false,
		"stock": "10000487.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气芒果",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/59b1ee7e3109933ef2.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31422,
		"pack_cost": "0.00",
		"sales": 22472,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E9CF8E09B97E7742",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E9CF8E09BDAE9442",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 1164,
				"code": "Z5E9CF8E09C1031898",
				"value": "冰沙"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E9CF8E09C46D2981",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E9CF8E09C7A12137",
				"value": "温"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78A7B33E9F1462",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD78A7B341F49717",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD78A7B345276190",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010008",
			"id": "4d47173fb5788fa2",
			"stock": "10000653.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/25d058d6ea2617f58e.jpg",
			"num": 1,
			"price": 29,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 29,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/25d058d6ea2617f58e.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪人气天后，选用奈雪自有草莓园采摘的新鲜草莓，搭配茉莉毛尖茶底，每一口都有草莓在舌尖跳跃，唇齿留香。",
		"use_spec": false,
		"stock": "10000653.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气草莓",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/25d058d6ea2617f58e.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31509,
		"pack_cost": "0.00",
		"sales": 48186,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1164,
				"code": "Z5D5D4DFB60D275726",
				"value": "冰沙"
			}, {
				"is_default": 0,
				"id": 582,
				"code": "Z5D5D4DFB6117D4323",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5D5D4DFB615623217",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78A8794EBD5601",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD78A87952955431",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD78A87956405441",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"id": 191
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010010018",
			"id": "01f781b43f0f9241",
			"stock": "10000822.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/1f666aac7e0e710ff0.jpg",
			"num": 1,
			"price": 33,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 100,
		"price": 33,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/1f666aac7e0e710ff0.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "草莓、蓝莓、树莓，三种莓果混合搭配，与茉莉毛尖一拍即合，清爽甘醇的茶香搭配浓郁果香，几重滋味在口腔里面碰撞，留下余味。",
		"use_spec": false,
		"stock": "10000822.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气莓莓莓",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/1f666aac7e0e710ff0.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "霸气鲜果茶",
	"is_show_backstage": 0
}, {
	"sort": 6,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/06/17/80c1d7b602d4a4a611.png?imageView2/0/w/200/h/200",
	"id": 2844,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 31428,
		"pack_cost": "0.00",
		"sales": 43445,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 347,
			"values": [{
				"is_default": 1,
				"id": 1256,
				"code": "Z5DEDBF09BB3F13909",
				"value": "标准"
			}],
			"name": "配料",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1167,
				"code": "Z5D5BAD0461C7A7478",
				"value": "标准（冰沙）"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD788293E0122727",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD788293E3E37828",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD788293E7C22375",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010100003",
			"id": "ff1500e3c4febc75",
			"stock": "10001379.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/4aa065559299892ec2.jpg",
			"num": 1,
			"price": 30,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 30,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/4aa065559299892ec2.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "以霸气芒果打底，加入带椰子果肉的冰淇淋球，冰淇淋加上芒果甜香，每一口都有热带感觉，喝前搅一搅，味道更好。",
		"use_spec": false,
		"stock": "10001379.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气冰淇淋芒果",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/4aa065559299892ec2.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31426,
		"pack_cost": "0.00",
		"sales": 53637,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 347,
			"values": [{
				"is_default": 1,
				"id": 1256,
				"code": "Z5DEDBEDB8A4EB2815",
				"value": "标准"
			}],
			"name": "配料",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1167,
				"code": "Z5D5BA4B2589C68376",
				"value": "标准（冰沙）"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78057D91AC1512",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD78057D959F8584",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD78057D998B1998",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010100001",
			"id": "d751af98a431f031",
			"stock": "10001474.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/04/26/57edf607a7290a450b.jpg",
			"num": 1,
			"price": 30,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 30,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/04/26/57edf607a7290a450b.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "以霸气草莓打底，加入椰子冰淇淋，搅拌后椰乳慢慢与草莓果肉汁、绿茶单宁、茉莉与椰香融合，口感顺滑、芳香纯美",
		"use_spec": false,
		"stock": "10001474.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气冰淇淋草莓",
		"images": "https://img-shop.qmimg.cn/s23107/2019/04/26/57edf607a7290a450b.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31427,
		"pack_cost": "0.00",
		"sales": 37083,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1219,
				"code": "Z5DEDBE065697C1943",
				"value": "标准(冰淇淋+水晶)"
			}, {
				"is_default": 0,
				"id": 1220,
				"code": "Z5DEDBE0656D745437",
				"value": "无配料"
			}, {
				"is_default": 0,
				"id": 1257,
				"code": "Z5DEDBE06570D57681",
				"value": "去水晶"
			}, {
				"is_default": 0,
				"id": 2066,
				"code": "Z5DEDBE06574555671",
				"value": "去冰淇淋"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1167,
				"code": "Z5D5BAB4B698953798",
				"value": "标准（冰沙）"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD78368657E92731",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD7836865B8F3442",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD7836865F2D5309",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1313010004",
			"id": "73e2eab6e586fe0c",
			"stock": "1001521.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/07/14/b38864bce8685c4dcd.png",
			"num": 1,
			"price": 33,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 100,
		"price": 33,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/07/14/b38864bce8685c4dcd.png?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "来自墨西哥的珍稀食材牛油果，制成绵细冰沙口感，与招牌茉莉毛尖结合，加入椰子冰淇淋及水晶冻，丰盛呈现，喝前搅一搅，味道更好。",
		"use_spec": false,
		"stock": "1001521.00",
		"type": 1,
		"is_label": 0,
		"name": "霸气冰淇淋牛油果",
		"images": "https://img-shop.qmimg.cn/s23107/2019/07/14/b38864bce8685c4dcd.png?imageView2/2/w/400/h/400"
	}],
	"name": "霸气冰淇淋鲜果茶",
	"is_show_backstage": 0
}, {
	"sort": 7,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/28/edd969e6c892853667.png?imageView2/0/w/200/h/200",
	"id": 2575,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 58706,
		"pack_cost": "0.00",
		"sales": 45890,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 347,
			"values": [{
				"is_default": 1,
				"id": 1256,
				"code": "Z5E7C5E9A166EE2215",
				"value": "标准"
			}, {
				"is_default": 0,
				"id": 2782,
				"code": "Z5E7C5E9A16B858986",
				"value": "奶油顶换奶盖"
			}, {
				"is_default": 0,
				"id": 2783,
				"code": "Z5E7C5E9A1723B4260",
				"value": "去奶油顶"
			}],
			"name": "配料",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E7C5E9A17FFF5424",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E7C5E9A1842D8160",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E7C5E9A1882F9233",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E7C5E9A18DEA8109",
				"value": "温"
			}, {
				"is_default": 0,
				"id": 1164,
				"code": "Z5E7C5E9A191CA1920",
				"value": "冰沙"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5E7C5E9A198D68448",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5E7C5E9A19CC31451",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5E7C5E9A1A0A76125",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040032",
			"id": "25c95dd4ff3ff12e",
			"stock": "9999142.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/10/ddba4cf4efe4036f3a.jpg",
			"num": 1,
			"price": 19,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 1,
		"price": 19,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/10/ddba4cf4efe4036f3a.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "\"吸“鲜”三部曲\n①、舀起香脆山核桃碎与进口淡奶油一起品尝\n②、插入细吸管，感受清香乌龙与醇香鲜牛乳混合的清爽\n③、搅拌淡奶油和鲜奶茶，收获不同口感体验\"",
		"use_spec": false,
		"stock": "9999142.00",
		"type": 1,
		"is_label": 0,
		"name": "奈雪清欢乌龙宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/10/ddba4cf4efe4036f3a.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31537,
		"pack_cost": "0.00",
		"sales": 36724,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1215,
				"code": "Z5D5E436D69F123375",
				"value": "标准(奶油顶)"
			}, {
				"is_default": 0,
				"id": 1216,
				"code": "Z5D5E436D6A3C97065",
				"value": "换奶盖"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 0,
				"id": 582,
				"code": "Z5E5E2C76E802F9971",
				"value": "标准冰"
			}, {
				"is_default": 1,
				"id": 584,
				"code": "Z5E5E2C76E79148820",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2C76E7CB97862",
				"value": "温"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2C76E839C6537",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DB24D584C3643652",
				"value": "标准糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040017",
			"id": "acb74a29da52f86a",
			"stock": "1000086.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/10/28/74ae56edf6e8a8a2ea.jpg",
			"num": 1,
			"price": 21,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 2,
		"price": 21,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/10/28/74ae56edf6e8a8a2ea.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "以鲜牛奶为底，不含茶，加入手工熬煮Q弹黑糖珍珠。全新升级顶部加盖法国总统稀奶油，撒上香脆烤椰条，一勺加一吸管的装备，等你探索味蕾宝藏（本产品的甜度来源于食材本身，没有额外加糖，不能调整糖度）",
		"use_spec": false,
		"stock": "1000086.00",
		"type": 1,
		"is_label": 0,
		"name": "黑糖宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2019/10/28/74ae56edf6e8a8a2ea.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31539,
		"pack_cost": "0.00",
		"sales": 63462,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1215,
				"code": "Z5D5E4694899BF3397",
				"value": "标准(奶油顶)"
			}, {
				"is_default": 0,
				"id": 1216,
				"code": "Z5D5E469489E271743",
				"value": "换奶盖"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 584,
				"code": "Z5E5E2CBDC1DA03229",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2CBDC223C5568",
				"value": "温"
			}, {
				"is_default": 0,
				"id": 582,
				"code": "Z5E5E2CBDC2A978507",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2CBDC2EC06314",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DB24DE85B7C89450",
				"value": "标准糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040020",
			"id": "d9bb2e315384e250",
			"stock": "999422.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/09/10/b5b05d6c7bff587984.jpg",
			"num": 1,
			"price": 25,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 25,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/09/10/b5b05d6c7bff587984.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "以鲜牛奶为底，加入升级甄选的芋泥和芋圆，从全新加盖的奶油顶开始享用，还有烤椰条的入口，让饮茶更有FUN。 （本产品的甜度来源于食材本身，没有额外加糖，不能调整糖度）",
		"use_spec": false,
		"stock": "999422.00",
		"type": 1,
		"is_label": 0,
		"name": "芋泥宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2019/09/10/b5b05d6c7bff587984.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31540,
		"pack_cost": "0.00",
		"sales": 34770,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1215,
				"code": "Z5D5E47A626DFD7089",
				"value": "标准(奶油顶)"
			}, {
				"is_default": 0,
				"id": 1216,
				"code": "Z5D5E47A62728E7883",
				"value": "换奶盖"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 584,
				"code": "Z5E5E2CD29798D9088",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2CD297D2C7840",
				"value": "温"
			}, {
				"is_default": 0,
				"id": 582,
				"code": "Z5E5E2CD2980E82682",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2CD29845F7461",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DD782765E5D75879",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5DD782765E9927290",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5DD782765ED0A3809",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": "茶饮含糖量较低，推荐标准做法，口味更佳"
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040023",
			"id": "ea94028944a81ad5",
			"stock": "9902092.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/12/05/ea97748a1528cac999.jpg",
			"num": 1,
			"price": 25,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 4,
		"price": 25,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/12/05/ea97748a1528cac999.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "金色山脉茶底加入香甜滑口的奶冻，甘冽的茶香搭配浓郁的奶香，还有嚼劲十足的黑糖珍珠配上Q弹滑爽的奶冻，奶油顶表面撒料的椰条，邀您在更香甜的酥脆中，感受宝藏茶的丰盛。",
		"use_spec": false,
		"stock": "9902092.00",
		"type": 1,
		"is_label": 0,
		"name": "金色山脉宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2019/12/05/ea97748a1528cac999.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 64563,
		"pack_cost": "0.00",
		"sales": 11528,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 347,
			"values": [{
				"is_default": 1,
				"id": 1256,
				"code": "Z5E8EC41DDB7994007",
				"value": "标准"
			}, {
				"is_default": 0,
				"id": 2877,
				"code": "Z5E8EC41DDBBA71325",
				"value": "奶油顶换酸奶"
			}, {
				"is_default": 0,
				"id": 2782,
				"code": "Z5E8EC41DDC2A01429",
				"value": "奶油顶换奶盖"
			}, {
				"is_default": 0,
				"id": 2783,
				"code": "Z5E8EC41DDC6ED3831",
				"value": "去奶油顶"
			}],
			"name": "配料",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 1167,
				"code": "Z5E8EC41DDCE542183",
				"value": "标准（冰沙）"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5E8EC41DDD6386350",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5E8EC41DDDA5D9881",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5E8EC41DDDE9E9011",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040035",
			"id": "766a1bdd56089a22",
			"stock": "99999349.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/26/79187a01f23e6f1e66.jpg",
			"num": 1,
			"price": 27,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 5,
		"price": 27,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/26/79187a01f23e6f1e66.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "①、舀：品尝入口即化进口淡奶油搭配新鲜芒果颗粒；\n②、搅：吸管搅动半杯料；\n③、吸：手工现煮水晶和奶冻、饱满进口红西柚颗粒",
		"use_spec": false,
		"stock": "99999349.00",
		"type": 1,
		"is_label": 0,
		"name": "杨枝甘露宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/26/79187a01f23e6f1e66.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 64565,
		"pack_cost": "0.00",
		"sales": 1312,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 1167,
				"code": "Z5E8EC7A280B3B7217",
				"value": "标准（冰沙）"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5E8EC7A2817EB6840",
				"value": "标准糖"
			}, {
				"is_default": 0,
				"id": 586,
				"code": "Z5E8EC7A281CEF4540",
				"value": "少糖"
			}, {
				"is_default": 0,
				"id": 1959,
				"code": "Z5E8EC7A28213C1795",
				"value": "不另外加糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040036",
			"id": "54e0be7204fc75b7",
			"stock": "99999841.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/26/edf9dd62faf1ef59e6.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 6,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/26/edf9dd62faf1ef59e6.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "吸入手工现煮水晶和奶冻,搭配饱满进口红西柚颗粒,顶部加上一颗冰淇淋球",
		"use_spec": false,
		"stock": "99999841.00",
		"type": 1,
		"is_label": 0,
		"name": "杨枝甘露冰淇淋宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/26/edf9dd62faf1ef59e6.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 59962,
		"pack_cost": "0.00",
		"sales": 5928,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 347,
			"values": [{
				"is_default": 1,
				"id": 1256,
				"code": "Z5E868CFF52ECC9249",
				"value": "标准"
			}, {
				"is_default": 0,
				"id": 2782,
				"code": "Z5E868CFF533E84000",
				"value": "奶油顶换奶盖"
			}, {
				"is_default": 0,
				"id": 2853,
				"code": "Z5E868CFF539CB2730",
				"value": "去红豆爆爆珠"
			}, {
				"is_default": 0,
				"id": 2854,
				"code": "Z5E868CFF53DCC3512",
				"value": "去维他豆奶冻"
			}, {
				"is_default": 0,
				"id": 2860,
				"code": "Z5E868CFF542252778",
				"value": "去红豆爆爆珠和维他豆奶冻"
			}],
			"name": "配料",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 582,
				"code": "Z5E81D4FE3CC801440",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E81D4FE3D0829383",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 584,
				"code": "Z5E81D4FE3D4744058",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E81D4FE3D8859124",
				"value": "温"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5E81D4FE3E5616034",
				"value": "标准糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040034",
			"id": "f177d3922c20e9ea",
			"stock": "99999479.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2020/04/03/7a1e4f9543edbbb5fb.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 7,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2020/04/03/7a1e4f9543edbbb5fb.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "\"春季限定产品\n①、进口淡奶油加入新鲜火龙果汁调色成粉色，搭配厚厚一层豆粉\n②、插入吸管搅拌超多底料；\n③、吸一口感受清香茉莉初雪茶、顺滑奶冻和红豆爆爆珠的口感\n（产品甜度来源于食材本身，不能调整糖度）\"",
		"use_spec": false,
		"stock": "99999479.00",
		"type": 1,
		"is_label": 0,
		"name": "樱花宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2020/04/03/7a1e4f9543edbbb5fb.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 46758,
		"pack_cost": "0.00",
		"sales": 9358,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 347,
			"values": [{
				"is_default": 1,
				"id": 1829,
				"code": "Z5E19DB100F8ED5977",
				"value": "标准配料"
			}, {
				"is_default": 0,
				"id": 2200,
				"code": "Z5E19DB10102046574",
				"value": "红豆沙换红豆爆爆珠"
			}, {
				"is_default": 0,
				"id": 1216,
				"code": "Z5E19DB101069C2680",
				"value": "换奶盖"
			}, {
				"is_default": 0,
				"id": 2197,
				"code": "Z5E19DB1010A859752",
				"value": "去红豆沙"
			}, {
				"is_default": 0,
				"id": 2198,
				"code": "Z5E19DB1010E9D2926",
				"value": "去维他奶冻"
			}, {
				"is_default": 0,
				"id": 2199,
				"code": "Z5E19DB10112BF3000",
				"value": "去红豆沙和维他奶冻"
			}],
			"name": "配料",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 0,
				"id": 582,
				"code": "Z5E5E2C0D607C51082",
				"value": "标准冰"
			}, {
				"is_default": 1,
				"id": 584,
				"code": "Z5E5E2C0D612ED2717",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2C0D616667150",
				"value": "温"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2C0D60BEF2246",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 1164,
				"code": "Z5E5E2C0D60F919911",
				"value": "冰沙"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DFAE77C0E12C8450",
				"value": "标准糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040031",
			"id": "e2ba0b52b93189b7",
			"stock": "9999213.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/12/19/cc5a2e76edcd0c8667.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/12/19/cc5a2e76edcd0c8667.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "维他奶原味豆奶加入日本精选特质的抹茶粉、泥状红豆沙、入口即化，顶部是醇香奶油和厚厚豆粉",
		"use_spec": false,
		"stock": "9999213.00",
		"type": 1,
		"is_label": 0,
		"name": "维他奶豆奶宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2019/12/19/cc5a2e76edcd0c8667.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 37058,
		"pack_cost": "0.00",
		"sales": 18522,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": true,
			"id": 347,
			"values": [{
				"is_default": 1,
				"id": 1215,
				"code": "Z5DB250C4DD1F98266",
				"value": "标准(奶油顶)"
			}, {
				"is_default": 0,
				"id": 1216,
				"code": "Z5DB250C4DD6787331",
				"value": "换奶盖"
			}, {
				"is_default": 0,
				"id": 1794,
				"code": "Z5DB250C4DDA063068",
				"value": "去黑糖珍珠"
			}, {
				"is_default": 0,
				"id": 1795,
				"code": "Z5DB250C4DDDAC5510",
				"value": "去旺仔奶冻"
			}, {
				"is_default": 0,
				"id": 1796,
				"code": "Z5DB250C4DE10C1138",
				"value": "黑糖珍珠换旺仔奶冻"
			}],
			"name": "配料",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 584,
				"code": "Z5E5E2C4E57CDF5900",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2C4E580FC8330",
				"value": "温"
			}, {
				"is_default": 0,
				"id": 582,
				"code": "Z5E5E2C4E584CC6352",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2C4E5889B2822",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 1164,
				"code": "Z5E5E2C4E58C785990",
				"value": "冰沙"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DABF3E46547A8514",
				"value": "标准糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040029",
			"id": "c4a6c3501d658add",
			"stock": "99999486.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/10/20/4b22b689015cf8dbb7.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/10/20/4b22b689015cf8dbb7.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "黑色爆谷米加费列罗，低温研磨而成的黑芝麻酱混合榛子奶，酱香味浓郁(本产品的甜度来源于食材本身，没有额外加糖，不能调整糖度)",
		"use_spec": false,
		"stock": "99999486.00",
		"type": 1,
		"is_label": 0,
		"name": "老佛爷宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2019/10/20/4b22b689015cf8dbb7.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 37055,
		"pack_cost": "0.00",
		"sales": 90199,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 347,
			"values": [{
				"is_default": 1,
				"id": 1215,
				"code": "Z5DB250B32C85D6736",
				"value": "标准(奶油顶)"
			}, {
				"is_default": 0,
				"id": 1216,
				"code": "Z5DB250B32CCB22003",
				"value": "换奶盖"
			}, {
				"is_default": 0,
				"id": 1794,
				"code": "Z5DB250B32D1355967",
				"value": "去黑糖珍珠"
			}, {
				"is_default": 0,
				"id": 1795,
				"code": "Z5DB250B32D7EE9440",
				"value": "去旺仔奶冻"
			}, {
				"is_default": 0,
				"id": 1796,
				"code": "Z5DB250B32DE6A2354",
				"value": "黑糖珍珠换旺仔奶冻"
			}],
			"name": "配料",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 584,
				"code": "Z5E5E2C2321B238817",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2C2321EF85781",
				"value": "温"
			}, {
				"is_default": 0,
				"id": 582,
				"code": "Z5E5E2C23222EB8554",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2C23226911326",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 1164,
				"code": "Z5E5E2C23229FC5210",
				"value": "冰沙"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DABF370BB8A43330",
				"value": "标准糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040028",
			"id": "e27d84349ef37fa9",
			"stock": "99998959.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/10/20/9fedfc4418663d1de8.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/10/20/9fedfc4418663d1de8.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "顶部酥脆山核桃碎搭配费列罗巧克力，加入榛子奶、旺仔奶冻，口感丰富(本产品的甜度来源于食材本身，没有额外加糖，不能调整糖度)",
		"use_spec": false,
		"stock": "99998959.00",
		"type": 1,
		"is_label": 0,
		"name": "Miss可可宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2019/10/20/9fedfc4418663d1de8.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 46756,
		"pack_cost": "0.00",
		"sales": 1494,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 347,
			"values": [{
				"is_default": 1,
				"id": 1829,
				"code": "Z5E19DB65BE87A9872",
				"value": "标准配料"
			}, {
				"is_default": 0,
				"id": 2200,
				"code": "Z5E19DB65BF0B39470",
				"value": "红豆沙换红豆爆爆珠"
			}, {
				"is_default": 0,
				"id": 2197,
				"code": "Z5E19DB65BF4566485",
				"value": "去红豆沙"
			}, {
				"is_default": 0,
				"id": 2198,
				"code": "Z5E19DB65BF7BC1240",
				"value": "去维他奶冻"
			}, {
				"is_default": 0,
				"id": 2199,
				"code": "Z5E19DB65BFB9D1406",
				"value": "去红豆沙和维他奶冻"
			}],
			"name": "配料",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 1210,
				"code": "Z5DFAE6B10829E9708",
				"value": "标准（去冰）"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DFAE6B1089347085",
				"value": "标准糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040030",
			"id": "71f657723173b3dd",
			"stock": "999999574.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/12/19/83e687b8fa13b44ee4.jpg",
			"num": 1,
			"price": 33,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 100,
		"price": 33,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/12/19/83e687b8fa13b44ee4.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "奈雪以维他奶原味豆奶的经典蓝色利乐包装为创意灵感，等比打造了一个plus版的维他奶限量宝藏瓶（附赠PVC袋）",
		"use_spec": false,
		"stock": "999999574.00",
		"type": 1,
		"is_label": 0,
		"name": "维他奶豆奶宝藏瓶",
		"images": "https://img-shop.qmimg.cn/s23107/2019/12/19/83e687b8fa13b44ee4.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "宝藏鲜奶茶",
	"is_show_backstage": 0
}, {
	"sort": 13,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/30/458c5a14fb2f190f96.png?imageView2/0/w/200/h/200",
	"id": 4669,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 31539,
		"pack_cost": "0.00",
		"sales": 63462,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 1215,
				"code": "Z5D5E4694899BF3397",
				"value": "标准(奶油顶)"
			}, {
				"is_default": 0,
				"id": 1216,
				"code": "Z5D5E469489E271743",
				"value": "换奶盖"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"is_default": 1,
				"id": 584,
				"code": "Z5E5E2CBDC1DA03229",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2CBDC223C5568",
				"value": "温"
			}, {
				"is_default": 0,
				"id": 582,
				"code": "Z5E5E2CBDC2A978507",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2CBDC2EC06314",
				"value": "去冰"
			}],
			"name": "温度",
			"id": 190
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DB24DE85B7C89450",
				"value": "标准糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040020",
			"id": "d9bb2e315384e250",
			"stock": "999422.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/09/10/b5b05d6c7bff587984.jpg",
			"num": 1,
			"price": 25,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 3,
		"price": 25,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/09/10/b5b05d6c7bff587984.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "以鲜牛奶为底，加入升级甄选的芋泥和芋圆，从全新加盖的奶油顶开始享用，还有烤椰条的入口，让饮茶更有FUN。 （本产品的甜度来源于食材本身，没有额外加糖，不能调整糖度）",
		"use_spec": false,
		"stock": "999422.00",
		"type": 1,
		"is_label": 0,
		"name": "芋泥宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2019/09/10/b5b05d6c7bff587984.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 37055,
		"pack_cost": "0.00",
		"sales": 90199,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 347,
			"values": [{
				"is_default": 1,
				"id": 1215,
				"code": "Z5DB250B32C85D6736",
				"value": "标准(奶油顶)"
			}, {
				"is_default": 0,
				"id": 1216,
				"code": "Z5DB250B32CCB22003",
				"value": "换奶盖"
			}, {
				"is_default": 0,
				"id": 1794,
				"code": "Z5DB250B32D1355967",
				"value": "去黑糖珍珠"
			}, {
				"is_default": 0,
				"id": 1795,
				"code": "Z5DB250B32D7EE9440",
				"value": "去旺仔奶冻"
			}, {
				"is_default": 0,
				"id": 1796,
				"code": "Z5DB250B32DE6A2354",
				"value": "黑糖珍珠换旺仔奶冻"
			}],
			"name": "配料",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 584,
				"code": "Z5E5E2C2321B238817",
				"value": "热"
			}, {
				"is_default": 0,
				"id": 2544,
				"code": "Z5E5E2C2321EF85781",
				"value": "温"
			}, {
				"is_default": 0,
				"id": 582,
				"code": "Z5E5E2C23222EB8554",
				"value": "标准冰"
			}, {
				"is_default": 0,
				"id": 583,
				"code": "Z5E5E2C23226911326",
				"value": "去冰"
			}, {
				"is_default": 0,
				"id": 1164,
				"code": "Z5E5E2C23229FC5210",
				"value": "冰沙"
			}],
			"name": "温度",
			"desc": null
		}, {
			"is_open_checkbox": false,
			"id": 191,
			"values": [{
				"is_default": 1,
				"id": 585,
				"code": "Z5DABF370BB8A43330",
				"value": "标准糖"
			}],
			"name": "糖度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1010040028",
			"id": "e27d84349ef37fa9",
			"stock": "99998959.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/10/20/9fedfc4418663d1de8.jpg",
			"num": 1,
			"price": 28,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 28,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/10/20/9fedfc4418663d1de8.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "顶部酥脆山核桃碎搭配费列罗巧克力，加入榛子奶、旺仔奶冻，口感丰富(本产品的甜度来源于食材本身，没有额外加糖，不能调整糖度)",
		"use_spec": false,
		"stock": "99998959.00",
		"type": 1,
		"is_label": 0,
		"name": "Miss可可宝藏茶",
		"images": "https://img-shop.qmimg.cn/s23107/2019/10/20/9fedfc4418663d1de8.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "热饮推荐",
	"is_show_backstage": 0
}, {
	"sort": 16,
	"icon": "https://img-shop.qmimg.cn/s23107/2019/04/28/612503f0fb3cd4ca74.png?imageView2/0/w/200/h/200",
	"id": 2924,
	"goods_list": [{
		"sell_time_status": 0,
		"id": 46760,
		"pack_cost": "0.00",
		"sales": 1185,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"id": 190,
			"values": [{
				"is_default": 1,
				"id": 612,
				"code": "Z5DFAE7EFE9ECD9078",
				"value": "冷"
			}],
			"name": "温度",
			"desc": null
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1313010014",
			"id": "c54eef36afbc6949",
			"stock": "999999903.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/12/19/e38b66de6f9521af49.jpg",
			"num": 1,
			"price": 15,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 15,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/12/19/e38b66de6f9521af49.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "维他奶原味豆奶和芋圆、芝士的口味碰撞，小小一杯藏着多层惊喜",
		"use_spec": false,
		"stock": "999999903.00",
		"type": 1,
		"is_label": 0,
		"name": "维他奶芋圆芝士杯",
		"images": "https://img-shop.qmimg.cn/s23107/2019/12/19/e38b66de6f9521af49.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31542,
		"pack_cost": "0.00",
		"sales": 842,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"id": 1284,
				"code": "Z5D5E4AE5E42809400",
				"value": "标准(奥利奥)"
			}, {
				"id": 1285,
				"code": "Z5D5E4AE5E49D05653",
				"value": "换草莓"
			}, {
				"id": 1282,
				"code": "Z5D5E4AE5E50B26372",
				"value": "换芒果"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"id": 612,
				"code": "Z5D5E4AE5E581D2537",
				"value": "冷"
			}],
			"name": "温度",
			"id": 190
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1313010011",
			"id": "6a0750fab695d833",
			"stock": "1000040.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/06/26/665c6e9b5d26ec9050.jpg",
			"num": 1,
			"price": 25,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 25,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/06/26/665c6e9b5d26ec9050.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "以芬芳绵细的香草冰淇淋雪球，搭配奥利奥饼干碎，清爽中透出深邃气质。",
		"use_spec": false,
		"stock": "1000040.00",
		"type": 1,
		"is_label": 0,
		"name": "金酒杯香草雪球",
		"images": "https://img-shop.qmimg.cn/s23107/2019/06/26/665c6e9b5d26ec9050.jpg?imageView2/2/w/400/h/400"
	}, {
		"sell_time_status": 0,
		"id": 31541,
		"pack_cost": "0.00",
		"sales": 2417,
		"cover_img": "",
		"property": [{
			"is_open_checkbox": false,
			"values": [{
				"id": 1281,
				"code": "Z5D5E4A463E8055728",
				"value": "标准(草莓)"
			}, {
				"id": 1282,
				"code": "Z5D5E4A463F1912904",
				"value": "换芒果"
			}, {
				"id": 1283,
				"code": "Z5D5E4A463FABD4950",
				"value": "换奥利奥"
			}],
			"name": "配料",
			"id": 347
		}, {
			"is_open_checkbox": false,
			"values": [{
				"id": 612,
				"code": "Z5D5E4A46406F16077",
				"value": "冷"
			}],
			"name": "温度",
			"id": 190
		}],
		"is_sell": true,
		"goods_type": 2,
		"entity": [{
			"spec_id": "",
			"trade_mark": "1313010010",
			"id": "a9730df9826ea5f5",
			"stock": "1000040.00",
			"spec_text": [],
			"spec": [],
			"image": "s23107/2019/06/27/3ba3f1ebc4f0b52882.jpg",
			"num": 1,
			"price": 25,
			"membership_price": 0
		}],
		"stall_code": "",
		"sort": 99,
		"price": 25,
		"unit": "件",
		"imageArr": [
			"https://img-shop.qmimg.cn/s23107/2019/06/27/3ba3f1ebc4f0b52882.jpg?imageView2/2/w/600/h/600"
		],
		"membership_price": 0,
		"use_property": 1,
		"unit_type": 0,
		"min_buy_num": 0,
		"specs": [],
		"content": "以浓醇绵柔的椰子冰淇淋雪球，混搭草莓果肉与Q滑晶冻，你会被她的热烈和艳丽感染。",
		"use_spec": false,
		"stock": "1000040.00",
		"type": 1,
		"is_label": 0,
		"name": "金酒杯椰子雪球",
		"images": "https://img-shop.qmimg.cn/s23107/2019/06/27/3ba3f1ebc4f0b52882.jpg?imageView2/2/w/400/h/400"
	}],
	"name": "美好甜品",
	"is_show_backstage": 0
}]
